import { Component, OnInit } from '@angular/core';
import { RegisterMerchantFormContainerComponent } from './register-merchant-form-container/register-merchant-form-container.component';
import { KeycloakService } from 'keycloak-angular';
import { MerchantRegistrationService } from '../../services/merchant-registration-service';

@Component({
  selector: 'app-register-merchant',
  templateUrl: './register-merchant.component.html',
  styleUrls: ['./register-merchant.component.css']
})
export class RegisterMerchantComponent implements OnInit {

  isMerchantCreatedSuccessfully : boolean = false;
  UserKeycloakGuidId!: string;
  isContentScrolled = false;
  constructor(private _keycloakService : KeycloakService,private apiService : MerchantRegistrationService){
    
    this._keycloakService
        .loadUserProfile()
        .then(e => {
          this.UserKeycloakGuidId = e.id!;
        });
  }
  scroll({reachedTop = false}) {
    this.isContentScrolled = !reachedTop;
  }
  ngOnInit(): void {
    this.GetMerchantStatus();
  }

  handleMerchantPost($event: any) {
    this.isMerchantCreatedSuccessfully = true;
    setTimeout(()=>{

      this.isMerchantCreatedSuccessfully = false;
    }, 50)
  }

  GetMerchantStatus(){

    // this.apiService.GetMerchantStatus(this.UserKeycloakGuidId)
    // .subscribe(resp =>{
    //   // this.isMerchantCreatedSuccessfully = resp.valueOf() > 0 ? true : false; 
    // })

  }

}
